import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { styleVisibility } from '../../common/visibility-helper';

@Component({
  selector: 'app-processing-button',
  templateUrl: './processing-button.html',
  styleUrls: ['./processing-button.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProcessingButtonComponent {
  @Input() raised = false;
  @Input() disabled = false;
  @Input() buttonText: string;
  @Input() isProcessing: boolean;
  @Input() translateParam: any;
  @Input() dataAction: string;

  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  styleVisibility: (v: boolean) => string = styleVisibility;

  onClick(): void {
    this.buttonClick.emit();
  }
}
